import { Heading } from '@raskrask-dk/rr-components'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import {
    BasisTypeCardsTemplate,
    CustomerTypeCardsTemplate,
    StyledBasisTypes,
} from '.'
import { useAppSelector } from '../../redux/hooks'
import { getIsLoading, getIsMobile } from '../../redux/reducers/appSettings'
import { PageTemplate } from '../chemistry/skeleton'
import { PropsBasisAndCustomer } from './props'

const BasisTemplate = ({
    customerHandler,
}: //basisTypeHandler - might be used later,
PropsBasisAndCustomer): ReactElement => {
    const { t } = useTranslation()

    const isLoading = useAppSelector((state) => getIsLoading(state))
    const isMobile = useAppSelector((state) => getIsMobile(state))

    const Title = useMemo(
        () =>
            !isMobile && (
                <Heading bold primary size={isMobile ? 5 : 4}>
                    {t('basistypes.title')}
                </Heading>
            ),
        [isMobile, t]
    )

    // Might be used later
    /* const basisTypeCards = useMemo(
        () => (
            <BasisTypeCardsTemplate
                basisTypes={basisTypeHandler.available}
                customerType={customerHandler.selected}
                isLoading={isLoading}
                onBasisTypeClick={basisTypeHandler.onClick}
            />
        ),
        [basisTypeHandler, customerHandler.selected, isLoading]
    ) */

    const customerTypeCards = useMemo(
        () => (
            <CustomerTypeCardsTemplate
                customerType={customerHandler.selected}
                customerTypes={customerHandler.available}
                isLoading={isLoading}
                onCustomerTypeClick={customerHandler.onClick}
            />
        ),
        [isLoading, customerHandler]
    )

    return (
        <PageTemplate
            Top={
                <StyledBasisTypes>
                    {Title}
                    {customerTypeCards}
                </StyledBasisTypes>
            }
            Body={<></>}
            Modal={<></>}
        />
    )
}

export default BasisTemplate
